export default {
    btn: {
        cursor: "pointer"
    }
}